import "@babel/polyfill";
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Provider  from '@react/react-spectrum/Provider';
import './i18n';
import {Provider as ReduxProvider} from 'react-redux';
//import configureStore from './stores/configureStore';
import store from './stores/store';
import * as intercptor from './Api';

// Polyfill for process to fix Webpack 5+ issues in browser
window.process = { env: {} };

//const store = configureStore();
intercptor.registerInterceptor();
ReactDOM.render((
    <Provider theme="light" scale="medium">
        <ReduxProvider store={store}>
            <App/>
        </ReduxProvider>
    </Provider>), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
